import { render, staticRenderFns } from "./profile-attendees.vue?vue&type=template&id=2ac96595&"
import script from "./profile-attendees.vue?vue&type=script&lang=ts&"
export * from "./profile-attendees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports